package com.xtream.data_kmp.di


import com.xtream.data_kmp.PreferencesRepo
import com.xtream.data_kmp.db.AppRoomDB
import com.xtream.data_kmp.db.repo.HomeStreamsRepository
import com.xtream.data_kmp.db.repo.LiveStreamsRepository
import com.xtream.data_kmp.db.repo.SearchStreamsRepository
import com.xtream.data_kmp.db.repo.SeriesStreamsRepository
import com.xtream.data_kmp.db.repo.UserRepo
import com.xtream.data_kmp.db.repo.VodStreamsRepository
import com.xtream.data_kmp.db.repo.WatchedLiveRepository
import com.xtream.data_kmp.db.repo.WatchedSeriesRepository
import com.xtream.data_kmp.db.repo.WatchedVodRepository
import com.xtream.data_kmp.remote.repo.PlayerServerRepo
import com.xtream.data_kmp.remote.repo.ServerConfigRepo
import com.xtream.data_kmp.remote.repo.XtreamRemoteRepo
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val dataModule = module {
    // Repositories
    single { HomeStreamsRepository(get()) }
    single { LiveStreamsRepository(get()) }
    single { SearchStreamsRepository(get()) }
    single { SeriesStreamsRepository(get()) }
    single { UserRepo(get(), get(), get(), get(), get(), get(), get()) }
    single { VodStreamsRepository(get()) }
    single { WatchedSeriesRepository(get()) }
    single { WatchedLiveRepository(get()) }
    single { WatchedVodRepository(get()) }
    single { XtreamRemoteRepo(get(), get(), get(), get(), get()) }
    singleOf(::ServerConfigRepo)
    singleOf(::PlayerServerRepo)
    singleOf(::PreferencesRepo)

    // DAOs


    single { get<AppRoomDB>().userDao() }
    single { get<AppRoomDB>().liveStreamsDao() }
    single { get<AppRoomDB>().vodDao() }
    single { get<AppRoomDB>().seriesDao() }
    single { get<AppRoomDB>().liveCategoriesDao() }
    single { get<AppRoomDB>().vodCategoriesDao() }
    single { get<AppRoomDB>().seriesCategoriesDao() }
    single { get<AppRoomDB>().liveFavoritesDao() }
    single { get<AppRoomDB>().vodFavoritesDao() }
    single { get<AppRoomDB>().seriesFavoritesDao() }
    single { get<AppRoomDB>().watchedLiveDao() }
    single { get<AppRoomDB>().watchedVodDao() }
    single { get<AppRoomDB>().watchedSeriesDao() }
}